const responseStatus = {
  success: 'ok',
};

export default responseStatus;
